import { bezieApp } from '../lib/bezieLib/main';
<template>
    <div class="playground">
        <!--<ContextBar/>-->
        
        <div style="width:100%;overflow: hidden">
            <!--<div style="/*position: absolute; top: 25%; width:inherit*/">-->
            <div class="center">
                <canvas id="canvas" class="is-canvas vcenter" :width="w" :height="h" style="z-index:1; /*border: 5px solid pink;*/"></canvas>
                <canvas id="outlineCanvas" class="is-outline-canvas vcenter" style="z-index:2; /*border: 5px solid gray;*/" :width="(2)*w" :height="(2)*h"></canvas>
            </div>

            <!--<div style="position: absolute; top: 50px; width:inherit">
            <div class="center" style="background:yellow">
                <canvas id="outlineCanvas" class="is-outline-canvas vcenter" style="z-index:2" :width="(2)*w" :height="(1.5)*h"></canvas>
            </div>-->
        </div>
    </div>
</template>

<script>
import { UIUpdate } from '../lib/bezieLib/UI/UIUpdate';
import ContextBar from './playground/ContextBar.vue';
import { initEvents } from '../lib/bezieLib/UI/UIEvents';
export default {
    name: 'Playground',
    props: ['bezieAppObj'],
    components: {
        //ContextBar
    },
    data: function(){
        return {
             w: 800,
             h: 600
        }
    },
    methods: {
    },
    watch: {
        bezieAppObj : function(val){
            console.log("loaded bezie app obj in playground");
            if(this.bezieAppObj){
                this.w = this.bezieAppObj.getDimension()[0];
                this.h = this.bezieAppObj.getDimension()[1];
            }
        }
    }
}

</script>

<style scoped>

.at-btn__icon{
    font-size: 14px !important;
}

.is-vertical-center-aligned{
    position: absolute;
    top: 25%;
    width: 100%;
}

.is-padded-10{
    padding: 10px;
}

.is-canvas{
  background: white
}

.center { 
  height: 94vh;
  position: relative;
  /*border: 3px solid green; */
}

.vcenter {
  margin: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>